"use client";

import type { ReactNode } from "react";

import { useAtcStatus } from "./add-to-cart-form";

interface ShippingNoteProps {
	/**
	 * The row for the server-rendered selection. Also the first client render, so it MUST
	 * be identical to `noteByQuantity[1]` when that map is supplied, or the buy box
	 * hydrates with a different sentence than it was served with.
	 */
	note: ReactNode;
	/**
	 * Pre-rendered rows keyed by quantity, for products whose quantity picker keeps its
	 * state on the client instead of navigating to another variant.
	 *
	 * The rows are built on the server (reference-currency labels included) for the same
	 * reason StickyBar's `priceContentByQuantity` is: formatting money in the browser would
	 * bypass the resolver and desync from the price directly above it. Omitted for
	 * pack-variant products, where picking a quantity navigates to `?variant=` and the
	 * server re-renders the whole buy box anyway.
	 */
	noteByQuantity?: Record<number, ReactNode>;
}

/** Picks the pre-rendered shipping row matching the quantity currently selected. */
export function ShippingNote({ note, noteByQuantity }: ShippingNoteProps) {
	const atcStatus = useAtcStatus();
	const quantity = atcStatus?.quantity ?? 1;
	return <>{noteByQuantity?.[quantity] ?? note}</>;
}
